var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "selecred-goods" },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "选择商品",
            visible: _vm.dialogVisible,
            width: "80%",
            "destroy-on-close": "",
            modal: false,
            top: "5vh",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.close,
          },
        },
        [
          _vm.applicableRangeType === 4
            ? _c("ListFilterVue", {
                attrs: {
                  FILTER_ITEMS: _vm.FILTER_ITEMS,
                  handleSearch: _vm.handleSearch,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-table",
            {
              ref: "tableRef",
              attrs: { data: _vm.tableData.list },
              on: { select: _vm.select, "select-all": _vm.selectAll },
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", align: "center", width: "50" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "ID",
                  prop: "id",
                  align: "center",
                  width: "100",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "编码",
                  prop: "skuCode",
                  align: "center",
                  width: "150",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "名称",
                  prop: "skuName",
                  align: "center",
                  "min-width": "100",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "零售价",
                  prop: "otPrice",
                  align: "center",
                  width: "100",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "状态",
                  prop: "listStatus",
                  align: "center",
                  width: "100",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return _c(
                        "el-tag",
                        {
                          attrs: {
                            type:
                              scope.row.listStatus == 1 ? "success" : "danger",
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              { 0: "未上架", 1: "已上架" }[scope.row.listStatus]
                            )
                          ),
                        ]
                      )
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "品牌",
                  prop: "brandName",
                  align: "center",
                  width: "100",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "供应商",
                  prop: "supplierName",
                  align: "center",
                  width: "200",
                  "show-overflow-tooltip": "",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("el-pagination", {
            staticStyle: { "text-align": "right", "margin-top": "10px" },
            attrs: {
              "page-sizes": [20, 40, 60, 80],
              "page-size": _vm.pageData.limit,
              "current-page": _vm.pageData.page,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.tableData.total,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.close } }, [_vm._v("取 消")]),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.submit } },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }